import { render, staticRenderFns } from "./FlagItem.vue?vue&type=template&id=16d13850"
import script from "./FlagItem.vue?vue&type=script&lang=js"
export * from "./FlagItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports